import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7595 4.2409C12.0133 4.49474 12.0133 4.90629 11.7595 5.16014L8.91924 8.00035L11.7595 10.8406C12.0133 11.0944 12.0133 11.506 11.7595 11.7598C11.5056 12.0136 11.0941 12.0136 10.8402 11.7598L8 8.91959L5.15979 11.7598C4.90595 12.0136 4.49439 12.0136 4.24055 11.7598C3.98671 11.506 3.98671 11.0944 4.24055 10.8406L7.08076 8.00035L4.24055 5.16014C3.98671 4.90629 3.98671 4.49474 4.24055 4.2409C4.49439 3.98706 4.90595 3.98706 5.15979 4.2409L8 7.08111L10.8402 4.2409C11.0941 3.98706 11.5056 3.98706 11.7595 4.2409Z"
      fill="currentColor"
    />
  </svg>
);

const CrossIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default CrossIcon;
